/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookBaseSimpleDto from './BookBaseSimpleDto';
import PaginationModel from './PaginationModel';

/**
 * The SearchingQueryResponseModelBookBaseSimpleDto model module.
 * @module model/SearchingQueryResponseModelBookBaseSimpleDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelBookBaseSimpleDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelBookBaseSimpleDto</code>.
     * @alias module:model/SearchingQueryResponseModelBookBaseSimpleDto
     */
    constructor() { 
        
        SearchingQueryResponseModelBookBaseSimpleDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelBookBaseSimpleDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelBookBaseSimpleDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelBookBaseSimpleDto} The populated <code>SearchingQueryResponseModelBookBaseSimpleDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelBookBaseSimpleDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [BookBaseSimpleDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelBookBaseSimpleDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/BookBaseSimpleDto>} result
 */
SearchingQueryResponseModelBookBaseSimpleDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelBookBaseSimpleDto;

